import { Link } from 'react-router-dom';
import { FaXmark, FaArrowUpRightFromSquare, FaGithub, FaBookOpen } from 'react-icons/fa6';
import { ModalProps } from './contracts/modal-props';
import { isRepoLink } from '../link-utils';

export function Modal(props: ModalProps) {
  const repo = isRepoLink(props.link);

  return (
    <dialog id={props.id} className="modal-dialog">
      <div className="terminal-card relative w-[min(34rem,92vw)] overflow-hidden">
        <div className="flex items-center gap-3 border-b border-border px-4 py-3">
          <span className="win-dots relative block h-2.5 w-2.5" aria-hidden />
          <span className="ml-8 truncate font-mono text-xs text-muted">{props.title}</span>
          <form method="dialog" className="ml-auto">
            <button
              aria-label="Close"
              className="flex h-7 w-7 items-center justify-center rounded-md text-muted transition-colors hover:bg-elevated hover:text-fg"
            >
              <FaXmark />
            </button>
          </form>
        </div>

        {props.image && (
          <img
            src={props.image}
            alt={props.title ?? 'project'}
            className="max-h-56 w-full border-b border-border object-cover"
          />
        )}

        <div className="p-6">
          <h3 className="font-mono text-xl font-bold text-fg">{props.title}</h3>
          <p className="mt-3 leading-relaxed text-muted">{props.mainInfo}</p>

          {props.link && (
            <a
              href={props.link}
              target="_blank"
              rel="noreferrer"
              className="mt-5 inline-flex items-center gap-2 rounded-lg bg-accent px-4 py-2 font-mono text-sm font-medium text-bg transition-transform hover:-translate-y-0.5"
            >
              {repo ? (
                <>
                  <FaGithub aria-hidden /> View source
                </>
              ) : (
                <>
                  Visit site <FaArrowUpRightFromSquare aria-hidden className="text-xs" />
                </>
              )}
            </a>
          )}

          {props.blogSlug && (
            <Link
              to={`/blog/${props.blogSlug}`}
              onClick={() =>
                (document.getElementById(props.id) as HTMLDialogElement | null)?.close()
              }
              className="mt-4 flex items-center gap-2 font-mono text-sm text-accent transition-colors hover:text-cyan"
            >
              <FaBookOpen aria-hidden /> Read the post
              <FaArrowUpRightFromSquare aria-hidden className="text-xs" />
            </Link>
          )}
        </div>
      </div>

      {/* Click outside to dismiss */}
      <form method="dialog" className="modal-backdrop-form">
        <button aria-label="Close">close</button>
      </form>
    </dialog>
  );
}
